import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    CollectionDeDossierJsonldCollectiondossierRead,
    DossierOpenSearchJsonldOpensearchDossierCollectionRead,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierCollection = DossierOpenSearchJsonldOpensearchDossierCollectionRead &
    Record<string, unknown>;

const useDossierCollection = () => {
    const { dossierOpenSearchApi, collectionApi } = useFormaliteService();
    let searchCollectionTimeout: number | undefined;

    let getDossierCollectionTimeout: number | undefined;

    const searchDossierCollection = (term: string): Promise<Array<DossierCollection>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchCollectionTimeout);
            const requestParameters = { q: term || undefined };

            searchCollectionTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchCollectionsGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierCollection>))
                    .catch(() => reject());
            }, 300);
        });

    const getDossierCollection = (
        idCollection: number,
    ): Promise<CollectionDeDossierJsonldCollectiondossierRead> =>
        new Promise((resolve, reject) => {
            clearTimeout(getDossierCollectionTimeout);

            getDossierCollectionTimeout = setTimeout(() => {
                collectionApi
                    .apiCollectionsDossiersIdGet({ id: `${idCollection}` })
                    .then((res) => {
                        resolve(res.data as CollectionDeDossierJsonldCollectiondossierRead);
                    })
                    .catch(() => reject());
            }, 300);
        });

    return { searchDossierCollection, getDossierCollection };
};

export default useDossierCollection;
